/**
 * EXPORTS
 */
export interface IAgent
{
    email: string;
    fullname: string;
    photo?: string;
    roles: IRoles;
    uid: string;
    username: string;
}

export interface IAgentById
{
    [key: string]: IAgent;
}

export interface IAgentState
{
    byId: IAgentById;
    hasCreateError: boolean;
    hasLoadError: boolean;
    hasRemoveError: boolean;
    hasUpdateError: boolean;
    isCreating: boolean;
    isLoading: boolean;
    isRemoving: boolean;
    isUpdating: boolean;
    metrics: IMetrics;
}

export interface ILoginMetrics
{
    byAgent: IStatusMetricsByAgent;
    byDate: IStatusMetricsByDate;
    statusChanges: IStatusChange[];
}

export interface IMetrics
{
    end: number | null;
    hasLoadError: boolean;
    isLoading: boolean;
    login: ILoginMetrics;
    start: number | null;
}

export interface IPeriod
{
    end: number;
    start: number;
}

export interface IRoles
{
    agent: boolean;
    softphone: boolean;
    supervisor: boolean;
}

export interface IStatusChange
{
    name: string;
    status: Statuses;
    timestamp: number;
    uid: number;
}

export interface IStatusMetrics
{
    away: number;
    name: string;
    offline: number;
    online: number;
    paused: number;
    standby: number;
    statuses: IStatusPeriod[];
    uid: number;
}

export interface IStatusMetricsByAgent
{
    [id: string]: IStatusMetrics;
}

export interface IStatusMetricsByDate
{
    [timestamp: number]: IStatusTimeByAgent;
}

export interface IStatusPeriod
{
    end: number;
    start: number;
    status: Statuses;
}

export interface IStatusTimeByAgent
{
    [uid: string]: Omit<IStatusMetrics, 'statuses'>;
}

export enum Role
{
    AGENT = 'agent',
    SOFTPHONE = 'softphone',
    SUPERVISOR = 'supervisor',
}

export enum Statuses
{
    AWAY = 2,
    OFFLINE = 0,
    ONLINE = 4,
    PAUSED = 1,
    STANDBY = 3,
}

export type StatusNames = 'away' | 'offline' | 'online' | 'paused' | 'standby';
